import axios from "axios";

const API_URL = "/api/dashboard";

export const getDashboardInfo = (actAsData) => {
  return axios.post(API_URL, actAsData).then((response) => {
    return response.data;
  });
};
